import { render, staticRenderFns } from "./AccountSupport.vue?vue&type=template&id=f806744c&"
import script from "./AccountSupport.vue?vue&type=script&lang=js&"
export * from "./AccountSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f806744c')) {
      api.createRecord('f806744c', component.options)
    } else {
      api.reload('f806744c', component.options)
    }
    module.hot.accept("./AccountSupport.vue?vue&type=template&id=f806744c&", function () {
      api.rerender('f806744c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/AccountSupport.vue"
export default component.exports